import React from "react";
import styled from "styled-components";

const ClientSection = styled.section`
  padding: 60px 0;
  background: white;
  border-top: 1px solid #f3f4f6;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled.h3`
  text-align: center;
  margin-bottom: 40px;
  font-family: "Inter", sans-serif;
  font-size: 1.1rem;
  color: var(--text-light);
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 500;
`;

const LogoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 40px;
  align-items: center;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }
`;

const LogoItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  transition: all 0.3s ease;
  padding: 20px;
  border-radius: 10px;

  &:hover {
    opacity: 0.8;
    background: #f9fafb;
  }
`;

const LogoText = styled.div`
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 1.2rem;
  color: var(--primary-color);
  text-align: center;
  letter-spacing: -0.5px;
`;

const ClientLogos = () => {
  const clients = ["AMAZON", "WALMART", "FEDEX", "UPS", "TARGET", "COSTCO"];

  return (
    <ClientSection>
      <Container>
        <SectionTitle>Trusted by Leading Companies</SectionTitle>
        <LogoGrid>
          {clients.map((client, index) => (
            <LogoItem key={index}>
              <LogoText>{client}</LogoText>
            </LogoItem>
          ))}
        </LogoGrid>
      </Container>
    </ClientSection>
  );
};

export default ClientLogos;
